// extracted by mini-css-extract-plugin
export default {"whatsapp":"styles_whatsapp__SVKRz","wrapper":"styles_wrapper__0LTPY"};